import { render } from "./WpeOptions.vue?vue&type=template&id=64c49982"
import script from "./WpeOptions.vue?vue&type=script&lang=js"
export * from "./WpeOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WpeOptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64c49982"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64c49982', __exports__)) {
    api.reload('64c49982', __exports__)
  }
  
  module.hot.accept("./WpeOptions.vue?vue&type=template&id=64c49982", () => {
    api.rerender('64c49982', render)
  })

}


export default __exports__